import { SubService, UtilityType } from '../types/utility.types';
import axios from './axiosConfig';

interface ApiResponse<T> {
  data: T;
}

export const getAllSubServices = async (): Promise<SubService[]> => {
  try {
    const response = await axios.get<ApiResponse<SubService[]>>('/utility-sub-services');
    return response.data.data || [];
  } catch (error) {
    console.error('Error fetching all sub-services:', error);
    return [];
  }
};

export const fetchSubServices = async (utilityType: UtilityType): Promise<SubService[]> => {
  try {
    // Audit 09 / F-118: server now uses the canonical title-case UtilityType
    // vocabulary — no client-side case munging.
    const response = await axios.get<ApiResponse<SubService[]>>(`/utility-sub-services/by-type/${utilityType}`);
    return response.data.data || [];
  } catch (error) {
    console.error('Error fetching sub-services:', error);
    return []; // Return empty array instead of throwing to prevent form errors
  }
};

export const createSubService = async (subServiceData: Omit<SubService, '_id'>): Promise<SubService> => {
  try {
    const response = await axios.post<ApiResponse<SubService>>('/utility-sub-services', subServiceData);
    return response.data.data;
  } catch (error) {
    
    throw error;
  }
};

export const updateSubService = async (id: string, subServiceData: Partial<SubService>): Promise<SubService> => {
  try {
    const response = await axios.put<ApiResponse<SubService>>(`/utility-sub-services/${id}`, subServiceData);
    return response.data.data;
  } catch (error) {
    
    throw error;
  }
};

export const deleteSubService = async (id: string): Promise<void> => {
  try {
    await axios.delete(`/utility-sub-services/${id}`);
  } catch (error) {
    console.error('Error deleting sub-service:', error);
    throw error;
  }
};
